import axios, { AxiosResponse } from 'axios';
import {
  CheckoutPayload,
  PaAccountProcess,
} from '@src/types/paAccountProcess.ts';
import { ProductOffer } from '@src/types/productsAddons';

export const getPaAccountProcess = (
  leeloo_user_uuid: string,
  leeloo_account_uuid: string
): Promise<AxiosResponse<PaAccountProcess>> => {
  return axios.get(
    `/pa-account/three-steps-process/${leeloo_user_uuid}/${leeloo_account_uuid}/`
  );
};

export const downloadCertificate = (
  leeloo_user_uuid: string,
  leeloo_account_uuid: string
): Promise<AxiosResponse<Blob>> => {
  return axios.get(
    `/pa-account/certificate/${leeloo_user_uuid}/${leeloo_account_uuid}/`,
    {
      responseType: 'blob',
    }
  );
};

export const getPaAccountCheckout = (
  leeloo_user_uuid: string,
  leeloo_account_uuid: string
): Promise<AxiosResponse<ProductOffer>> => {
  return axios.get(
    `/pa-account/checkout/${leeloo_user_uuid}/${leeloo_account_uuid}/`
  );
};

export const confirmChoice = (
  leeloo_user_uuid: string,
  leeloo_account_uuid: string,
  product_id: number
): Promise<AxiosResponse<PaAccountProcess>> => {
  return axios.post(`/pa-account/three-steps-process/pa-packages/confirm/`, {
    leeloo_user_uuid,
    leeloo_account_uuid,
    product_id,
  });
};

export const getCreatePaAccountAddon = (
  subType: string,
  leeloo_user_uuid: string,
  leeloo_account_uuid: string
) => {
  return axios.get(
    `/pa-account/checkout/${leeloo_user_uuid}/${leeloo_account_uuid}/${subType}/`
  );
};

export const submitCreatePaAccountCheckout = (
  data: CheckoutPayload
): Promise<AxiosResponse<{ id: string; url: string }>> => {
  return axios.post(`/pa-account/checkout/`, data);
};

export const confirmToPa = (
  leeloo_user_uuid: string,
  leeloo_account_uuid: string
): Promise<AxiosResponse<boolean>> => {
  return axios.post(`/confirm-to-pa/`, {
    leeloo_user_uuid,
    leeloo_account_uuid,
  });
};
